import { Box, Link, Typography } from "@mui/material";

import type { FC } from "react";

export const UnsplashImageAttribution: FC<{ name: string; url?: string }> = ({ name, url }) => {
  const urlParams = new URLSearchParams();
  urlParams.set("utm_source", "ChangeEngine");
  urlParams.set("utm_medium", "referral");
  const params = urlParams.toString();

  return (
    <Box
      className="unsplash-attribution"
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        px: 1.5,
        py: 0.75,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        color: "white",
        opacity: 0,
        transition: "opacity 150ms ease-in-out",
      }}
    >
      <Typography variant="body2" sx={{ lineHeight: 1.2 }}>
        {"Photo by "}
        {url ? (
          <Link href={`${url}?${params}`} target="_blank" color="inherit" underline="hover">
            {name}
          </Link>
        ) : (
          name
        )}
        {" on "}
        <Link
          href={`https://www.unsplash.com?${params}`}
          target="_blank"
          color="inherit"
          underline="hover"
        >
          Unsplash
        </Link>
      </Typography>
    </Box>
  );
};
